<template>
  <b-container class="px-0" >

    <b-row no-gutters>
      <b-col class="pt-5">
        <b-card header-tag="header" >
          <template v-slot:header>
            <h6 class="mb-0">Admin login</h6>
          </template>
          <template>
            <h4>Use admin login/password</h4>
          </template>
          <b-card-text>

            <b-form v-on:keydown.enter="signIn">

              <reach-input
                  label="Login"
                  :formField="loginForm.login"
                  hint="Admin login"
              >
              </reach-input>
              <reach-input
                  label="Password"
                  :formField="loginForm.password"
                  type="password"
              >
              </reach-input>

            </b-form>
          </b-card-text>

          <b-button
              :disabled="this.loginForm.login.value === '' || this.loginForm.password.value === ''"
              variant="primary" @click="signIn()">Login
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import ChangePasswordForm from "@/components/users/ChangePasswordForm";
import AdminLoginForm from "@/admin/AdminLoginForm";
import Client from "@/utils/Client";
import Rpc from "@/Rpc";
import RpcMustWaitException from "@/server/com/silkplm/rpc/RpcMustWaitException";
import InputLock from "@/utils/InputLock";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import SessionManager from "@/utils/SessionManager";

export default {
  name: "AdminSignIn",
  components: {ReachInput},

  async mounted(){

  },

  methods: {

    async signIn(){
      let user = null;
      try{
        Client.lockDuringNextRequest();
        user = await Rpc.Admin.signIn(this.loginForm.login.value, this.loginForm.password.value);
        SessionManager.setUserInfo(user);
      } catch (e) {
          console.log(e);
          this.loginForm.generalFeedback = "Server error - please try again in few minutes";
      }

    }

  },

  data: () => ({
    loginForm: new AdminLoginForm()
  })
}

</script>
